import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { makeStyles } from 'tss-react/mui';
import { Box, Typography } from '@mui/material';
import { PhoneAndroidOutlined } from '@mui/icons-material';
import RepeatAppDownloadModal from '@components/Modals/RepeatAppDownloadModal/RepeatAppDownloadModal';
import { useFeature } from 'flagged';
const useStyles = makeStyles()((theme) => ({
    root: {
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        backgroundColor: '#1e1e1f',
        borderRadius: '6px',
        color: 'white',
        padding: theme.spacing(0.75, 1),
        gap: 8,
    },
    icon: {
        fontSize: 24,
    },
    text: {
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
    },
    title: {
        fontSize: '12px',
        fontWeight: 500,
    },
    badge: {
        position: 'absolute',
        right: '-4px',
        top: '-4px',
        padding: '3px',
        backgroundColor: '#00ACF6',
        color: theme.palette.common.white,
        fontSize: '8px',
        borderRadius: '5px 5px 5px 0',
    },
}));
const AppDownloadDesktopSection = () => {
    const { classes } = useStyles();
    const [isShow, setIsShow] = useState(false);
    const shouldHideDownloadMobileAppButton = !!useFeature('disable_download_mobile_app_button');
    if (shouldHideDownloadMobileAppButton) {
        return _jsx(_Fragment, {});
    }
    return (_jsxs(_Fragment, { children: [_jsxs(Box, { component: "button", className: classes.root, onClick: () => setIsShow(true), children: [_jsx(PhoneAndroidOutlined, { className: classes.icon }), _jsx(Box, { className: classes.text, children: _jsx(Typography, { variant: "body2", className: classes.title, children: "Download mobile app" }) }), _jsx(Box, { className: classes.badge, children: "NEW" })] }), _jsx(RepeatAppDownloadModal, { show: isShow, handleClose: () => setIsShow(false) })] }));
};
export default AppDownloadDesktopSection;
